//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    productUrl: {
      type: Object,
      default: null,
    },
    isSelect: {
      type: Boolean,
    },
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isVerified: this.isSelect && this.user.email_verified,
    };
  },
  computed: {
    founderName() {
      const { first_name: fName, last_name: lName, username } = this.user;
      return `${fName || ''} ${lName || ''}`.trim() || username;
    },
  },
};
